import React, {Component} from 'react';
import moment from "moment";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import "./week_day_long.css";

export default class WeekDayLong extends Component {
	render() {
		function parseTime(time) {
			this.moment = moment(time, "HH:mm")
			this.minutes = (this.moment.hours() * 60) + this.moment.minutes();
		}

		function trimMinutes(time) {
			return moment(time, "HH:mm:ss").format("HH:mm");
		}

		let llegada = this.props.moves.find((move)=> {
			return move.render === 0
		});
		let salida = this.props.moves.find((move)=> {
			return move.render === 2
		});
		let inters = this.props.moves.filter((move)=>move.render === 1).sort((a, b)=> {
			return moment(a.salida, "HH:mm:ss").toDate() - moment(b.salida, "HH:mm:ss").toDate();
		});
		let hours = [];
		let lastHour = null;
		if (llegada) {
			let horaLlegada = new parseTime(llegada.regreso);
			lastHour = horaLlegada;
			hours.push(
				<div key={hours.length} style={{
					width: `${(100 / (24 * 60)) * (horaLlegada.minutes)}%`
				}} className={`cell trip ${this.context.getActive() === llegada.id ? "active-day" : ""}`}
					 onClick={(e)=> {
						 e.stopPropagation();
						 this.context.setActive(llegada.id);
					 }}>{llegada.destino} &#9873; {trimMinutes(llegada.regreso)}</div>
			);
			if (inters.length > 0) {
				let firstInter = new parseTime(inters[0].salida);
				hours.push(
					<div key={hours.length} style={{
						width: `${(100 / (24 * 60)) * (firstInter.minutes - lastHour.minutes)}%`
					}} className="cell"></div>
				);
			} else {
				if (!salida) {
					hours.push(
						<div key={hours.length} style={{
							width: `${(100 / (24 * 60)) * ((24 * 60) - horaLlegada.minutes)}%`
						}} className="cell"></div>
					);
				}
			}
		}
		if (inters.length > 0) {
			if (!llegada) {
				//add padding
				let minutosTranscurridos = new parseTime(inters[0].salida).minutes;
				hours.push(
					<div key={hours.length} style={{
						width: `${(100 / (24 * 60)) * (minutosTranscurridos)}%`
					}} className="cell"></div>
				);
			}
			for (let i = 0; i < inters.length; i++) {
				let move = inters[i];
				let horaSalida = new parseTime(move.salida);
				let horaRegreso = new parseTime(move.regreso);
				let horasTranscurridas = horaRegreso.minutes - horaSalida.minutes;
				lastHour = horaRegreso;
				hours.push(
					<div key={hours.length} style={{
						width: `${(100 / (24 * 60)) * (horasTranscurridas)}%`
					}} className={`cell trip ${this.context.getActive() === move.id ? "active-day" : ""}`}
						 onClick={(e)=> {
							 e.stopPropagation();
							 this.context.setActive(move.id)
						 }}>{trimMinutes(move.salida)} &#9872; {move.destino} &#9873; {trimMinutes(move.regreso)}</div>
				);
				let next = inters[i + 1];
				if (next) {
					let salidaNext = new parseTime(next.salida);
					hours.push(
						<div key={hours.length} style={{
							width: `${(100 / (24 * 60)) * (salidaNext.minutes - lastHour.minutes)}%`
						}} className="cell"></div>
					);
				}
			}
			if (!salida) {
				let horasTranscurridas = lastHour.minutes;
				hours.push(
					<div key={hours.length} style={{
						width: `${(100 / (24 * 60)) * ((24 * 60) - horasTranscurridas)}%`
					}} className="cell"></div>
				);
			}
		}
		if (salida) {
			let horaSalida = new parseTime(salida.salida);
			if (!lastHour) {
				hours.push(
					<div key={hours.length} style={{
						width: `${(100 / (24 * 60)) * (horaSalida.minutes)}%`
					}} className="cell"></div>
				);
				hours.push(
					<div key={hours.length} style={{
						width: `${(100 / (24 * 60)) * ((24 * 60) - horaSalida.minutes)}%`
					}} className={`cell trip ${this.context.getActive() === salida.id ? "active-day" : ""}`}
						 onClick={(e)=> {
							 e.stopPropagation();
							 this.context.setActive(salida.id);
						 }}>{trimMinutes(salida.salida)} &#9872; {salida.destino}</div>
				);
			} else {
				hours.push(
					<div key={hours.length} style={{
						width: `${(100 / (24 * 60)) * (horaSalida.minutes - lastHour.minutes)}%`
					}} className="cell"></div>
				);
				hours.push(
					<div key={hours.length} style={{
						width: `${(100 / (24 * 60)) * ((24 * 60) - horaSalida.minutes)}%`
					}} className={`cell trip ${this.context.getActive() === salida.id ? "active-day" : ""}`}
						 onClick={(e)=> {
							 e.stopPropagation();
							 this.context.setActive(salida.id);
						 }}>{trimMinutes(salida.salida)} &#9872; {salida.destino}</div>
				);
			}
		}
		let content = this.props.show ? (
			<div className={`day-long ${this.props.show ? "" : "hide"}`} ref={this.props.refQ}>
				{hours}
			</div>
		) : null;
		return (
			<ReactCSSTransitionGroup transitionName="example" transitionEnterTimeout={300} transitionLeaveTimeout={300}>
				{content}
			</ReactCSSTransitionGroup>
		)
	}
}

WeekDayLong.contextTypes = {
	setActive: React.PropTypes.func,
	getActive: React.PropTypes.func
}


/** WEBPACK FOOTER **
 ** ./src/components/week_day_long.js
 **/